package com.islamicmedia.shared.domain.model

/**
 * The ten standard concerns every analysis checks, spelled exactly as the server's
 * PromptTemplates.CONCERN_CATEGORIES (which is what arrives in [Concern.category]).
 */
val STANDARD_CONCERN_CATEGORIES = listOf(
    "Islamic Principles",
    "Profanity",
    "Immodest Clothing",
    "Sexual Content",
    "LGBTQ+ Content",
    "Violence",
    "Substance Abuse",
    "Gambling",
    "Magic & Sorcery",
    "Disrespect to Elders",
)

/**
 * Standard concerns this result checked and found nothing for. The server sends only findings, so
 * result screens list these under the concern cards with a "None found" label, so a parent can see
 * every concern was looked at rather than wonder whether one was skipped.
 *
 * Matching ignores case, spacing and "&" vs "and", so older results whose categories were spelled
 * slightly differently don't get a duplicate row.
 */
fun AnalysisResult.clearConcernCategories(): List<String> {
    val found = concerns.map { categoryKey(it.category) }.toSet()
    return STANDARD_CONCERN_CATEGORIES.filter { categoryKey(it) !in found }
}

/**
 * The name a concern category is SHOWN under. The server's names stay as they are (they are prompt and
 * cache keys, and what the "None found" match above compares), so only the label a person reads changes.
 * Owner, 2026-11-04: "Immodest Clothing" reads "Inappropriate Clothing".
 */
fun concernDisplayName(category: String): String =
    if (categoryKey(category) == "immodestclothing") "Inappropriate Clothing" else category

private fun categoryKey(category: String): String =
    category.lowercase().replace("&", "and").filter { it.isLetterOrDigit() }
